<template>
  <a-card v-if="pageLoading">
    <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading" />
  </a-card>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'" v-else>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }">
        <a-card :loading="pageLoading" class="margin-bottom">
          <div slot="title">Approval Request Guarantee</div>

          <div class="m-card-body">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>No Transaction</span>
                <span class="m-list-desc">{{
                  data.header.no_trans
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Date Request</span>
                <span class="m-list-desc">{{
                  moment(data.header.date_guarantee).format(
                    this.getDefaultDateFormat
                  )
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>TLC Create</span>
                <span class="m-list-desc">{{ data.header.tlc_create }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Site</span>
                <span class="m-list-desc">{{ data.header.location }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Due Date</span>
                <span class="m-list-desc">{{ moment(data.header.start_due_dt).format(
                  this.getDefaultDateFormat
                ) }} ~ {{ moment(data.header.end_due_dt).format(
  this.getDefaultDateFormat
) }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Nominal</span>
                <span class="m-list-desc">{{ formatCurrency(data.currency, data.header.nominal) }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Project Name</span>
                <span class="m-list-desc">{{
                  data.header.name_project
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>
                  {{ data.header.type == 'As Companion' ? 'Receiver Project' : 'Companion Name' }}</span>
                <span class="m-list-desc">{{ data.header.recieve_project }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Contact Person</span>
                <span class="m-list-desc">{{ data.header.contact_person }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Note</span>
                <span class="m-list-desc">{{ data.header.note }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Type</span>
                <span class="m-list-desc">{{ data.header.type }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Document</span>
                <span class="m-list-desc margin-top">
                  <a-button class="margin-top ant-menu-submenu ant-menu-submenu-selected" icon="download" size="default"
                    @click="handlePreview(data.header.file_attachment)">View Document</a-button>
                </span>
              </li>
            </ul>
          </div>
        </a-card>

        <a-collapse class="margin-top" activeKey>
          <a-collapse-panel key="1">
            <div class="m-display-flex space-between align-middle" slot="header">
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="data.last_status" />
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ data.user_pembuat.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ data.user_pembuat.tanggal }}</h4>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item v-for="workflow in data.status" :key="workflow.step_no"
                :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'red' : workflow.status === 'Waiting' ? 'grey' : 'green'">
                <div class="m-timeline-title">
                  {{
                    workflow.actor === null ? workflow.jenis : workflow.actor
                  }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove" v-if="workflow.tanggal_aksi !== null">
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span class="m-text-small" v-if="workflow.remark == null || workflow.remark == ''">Tidak Ada
                    Catatan</span>
                  <span class="m-text-small" v-else>{{ workflow.remark }}</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>

        <a-card class="margin-top" :loading="pageLoading" v-if="data.jenis.toLowerCase() === 'approve'">
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea placeholder="Write the note here ... " :rows="2" v-decorator="['catatan']" />
            </a-form-item>
            <a-form-item label="Actions">
              <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Password">
              <a-input type="password" placeholder="Password"
                v-decorator="['password', { rules: [{ required: true }] }]" />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button @click="handleSubmit" block type="primary" html-type="submit">Save</a-button>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  mixins: [CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
    ]),
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_bidbond_request",
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.data = {
            type: response.data.header[0].type,
            header: response.data.header[0],
            actor: response.data.tlc,
            currency: response.data.currency,
            id: response.data.header[0].bidbond_request_id,
            jenis: response.data.jenis,
            last_status: response.data.last_status,
            user_pembuat: {
              tlc: response.data.header[0].tlc_create,
              tanggal: response.data.header[0].date_guarantee,
              status: "Created",
            },
            status: response.data.status_app,
            aksi: response.data.aksi,
          };
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
        });
    },
    handlePrint() { },
    handleAction() { },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.pageLoading = false;
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.data.id);
        postData.append("status", values.aksi);
        postData.append(
          "remark",
          values.catatan !== undefined ? values.catatan : ""
        );
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_bidbond_request",
          processData: false,
          data: postData,
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.displayMessage("wrong-password");
            }
            this.pageLoading = false;
          });
      });
    },
    handlePreview(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
  },
};
</script>

<style></style> 